const initialState = {
  ippmFilters: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'IPPM.SET_IPPM_FILTERS':
      return {
        ...state,
        ippmFilters: action.ippmFilters,
      };

    default:
      return state;
  }
};
